"use client"

import FooterMedia from "@/components/footer-media"
import { TamdaMediaFooterViewClientProps } from "@/types/types"

export function TamdaMediaFooterViewClient({
  locale,
  hotCategory,
  regularCategory1,
  regularCategory2,
  regularCategory3,
  phone,
  email,
  advertisingContact,
  facebookUrl,
  youtubeUrl,
  slogan,
  copyrightText,
  logoImage,
  facebookIcon,
  youtubeIcon,
  className = "",
}: TamdaMediaFooterViewClientProps) {
  return (
    <FooterMedia
      locale={locale}
      logoImage={logoImage || ""}
      slogan={slogan || ""}
      hotCategory={hotCategory}
      regularCategory1={regularCategory1}
      regularCategory2={regularCategory2}
      regularCategory3={regularCategory3}
      phone={phone || ""}
      email={email || ""}
      advertisingContact={advertisingContact || ""}
      facebookIcon={facebookIcon || ""}
      facebookUrl={facebookUrl || ""}
      youtubeIcon={youtubeIcon || ""}
      youtubeUrl={youtubeUrl || ""}
      copyrightText={copyrightText || ""}
      className={className}
    />
  )
}
